import {
  FIREBASE_API_KEY,
  FIREBASE_messagingSenderId,
  FIREBASE_appId,
  FIREBASE_authDomain,
  FIREBASE_projectId,
  FIREBASE_storageBucket,
} from "apis/private/apis";

export default {
  apiKey: FIREBASE_API_KEY,
  authDomain: FIREBASE_authDomain,
  projectId: FIREBASE_projectId,
  storageBucket: FIREBASE_storageBucket,
  messagingSenderId: FIREBASE_messagingSenderId,
  appId: FIREBASE_appId,
}